module.exports = __webpack_public_path__ + "img/dhl.ddcbf5ce.svg";